import React from 'react';
import { FormFieldV2 as FormField, AritoIcon } from '@/components/custom/erp';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

function HeaderTab(): React.JSX.Element {
  return (
    <div className='p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        <div className='space-y-2 md:space-y-2'>
          {/* Customer Code Field */}
          <div className='flex items-center gap-2'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã khách hàng</Label>
              <FormField type='text' name='customerCode' />
            </div>

            {/* Customer Type Field */}
            <div className='flex flex-col gap-2 sm:flex-row sm:items-center'>
              <div className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                <FormField
                  type='select'
                  name='customerType'
                  options={[{ value: 'doanh_nghiep', label: 'Doanh nghiệp' }]}
                  defaultValue='doanh_nghiep'
                />
              </div>
              <div className='flex items-center gap-x-6'>
                <div className='flex items-center gap-x-1'>
                  <input type='checkbox' name='isCustomer' defaultChecked={true} className='h-4 w-4 accent-gray-500' />
                  <Label>Khách hàng</Label>
                </div>
                <div className='flex items-center gap-x-1'>
                  {/* <FormField type='checkbox' name='isSupplier' defaultChecked={true} /> */}
                  <input type='checkbox' name='isSupplier' defaultChecked={true} className='h-4 w-4 accent-gray-500' />

                  <Label>Nhà cung cấp</Label>
                </div>
              </div>
            </div>
          </div>

          {/* Customer Name Field */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khách hàng</Label>
            <FormField type='text' name='customerName' />
          </div>

          {/* Alternative Name Field */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
            <FormField type='text' name='alternativeName' />
          </div>

          {/* Address Field */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Địa chỉ</Label>
            <FormField type='text' name='address' />
          </div>

          {/* Tax Code Field */}
          <div className='flex items-center gap-2'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã số thuế</Label>
              <div className='flex items-center gap-x-2'>
                <FormField type='text' name='taxCode' />
                <Button type='button' variant='outline' size='icon' className='h-8 w-8 rounded border-gray-300 p-0'>
                  <AritoIcon icon={15} className='shrink-0' />
                </Button>
              </div>
            </div>

            {/* Contact Person Field */}
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Người liên hệ</Label>
              <FormField type='text' name='contactPerson' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderTab;
